import { render, staticRenderFns } from "./ModeAndViewportToolbar.vue?vue&type=template&id=bdeb88f6&scoped=true&"
import script from "./ModeAndViewportToolbar.vue?vue&type=script&lang=js&"
export * from "./ModeAndViewportToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ModeAndViewportToolbar.vue?vue&type=style&index=0&id=bdeb88f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeb88f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/laveto/new.laveto.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdeb88f6')) {
      api.createRecord('bdeb88f6', component.options)
    } else {
      api.reload('bdeb88f6', component.options)
    }
    module.hot.accept("./ModeAndViewportToolbar.vue?vue&type=template&id=bdeb88f6&scoped=true&", function () {
      api.rerender('bdeb88f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "galaxy/modules/Canvas/resources/js/editor/admin/ModeAndViewportToolbar.vue"
export default component.exports